import { faRemove } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, ReactNode } from 'react';
import { MAIN_PANEL_OFFSET } from '../../../constants/constants';
import { useAppDispatch } from '../../../core/rootHooks';
import { setFeature, setSubtab, setTab } from '../../../routing/pageContextSlice';

interface IDashboardCardProps {
	children: ReactNode;
}

const DashboardCard: FC<IDashboardCardProps> = (props) => {
	const dispatch = useAppDispatch();

	const onCloseButtonClick = () => {
		// Clear selection and close the dashboard by resetting feature, tab, and subtab
		dispatch(setFeature(null));
		dispatch(setTab(undefined));
		dispatch(setSubtab(undefined));
	};

	return (
		<div
			className={`absolute z-20 bg-msi-white-color items-center overflow-hidden justify-center`}
			style={{
				top: MAIN_PANEL_OFFSET.top,
				left: MAIN_PANEL_OFFSET.left,
				right: MAIN_PANEL_OFFSET.right,
				bottom: MAIN_PANEL_OFFSET.bottom,
			}}
		>
			<div className="bg-msi-white-color mb-2 overflow-hidden rounded h-full">
				<FontAwesomeIcon
					icon={faRemove}
					size="1x"
					className="hover:cursor-pointer hover:text-msi-darkblue-color text-msi-black-color"
					style={{
						position: 'absolute',
						right: 6,
						top: 5,
					}}
					onClick={onCloseButtonClick}
				/>
				<div className="flex w-full h-full pt-6 pb-3 pl-2 pr-2 justify-center center">{props.children}</div>
			</div>
		</div>
	);
};

export default DashboardCard;
